import { ButtonDefault, ButtonText } from '@/components/common/Button'
import { InputMenu } from '@/components/common/Input'
import { LinkRoute } from '@/components/common/Link'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type IconType } from '@/defs/icon'

type Props = {
  link: {
    icon: IconType
    label: string
    options: {
      href?: string
      label: string
      name?: string
    }[]
  }
  variant?: 'text'
}

export const CardLinkButton = ({ link: { icon, label, options }, variant }: Props) => {
  const [option] = options

  if (!option) return null

  const isMenu = options.length > 1
  const rootProps = isMenu ? ({ as: 'div' } as const) : ({ as: 'LinkRoute', href: option.href } as const)

  const content = (
    <IconWithLabel
      iconAfter={isMenu && 'caretDown'}
      iconAfterSize='sm'
      iconBefore={icon}
      iconBeforeMargin={variant === 'text' ? 'sm' : undefined}
      wrapNone
    >
      {isMenu ? label : option.label}
    </IconWithLabel>
  )

  const button =
    variant === 'text' ? (
      <ButtonText colorScheme='surface' hover='accent' size='sm' underlined {...rootProps}>
        {content}
      </ButtonText>
    ) : (
      <ButtonDefault colorScheme='dark' size='sm' {...rootProps}>
        {content}
      </ButtonDefault>
    )

  if (!isMenu) return button

  const menuOptions = options.map(({ href, name }) => ({
    label: <LinkRoute href={href}>{name}</LinkRoute>,
  }))

  return (
    <InputMenu aria-label={label} options={menuOptions} width='maxcontent'>
      {button}
    </InputMenu>
  )
}
